import axios from "axios";
/* eslint-disable */

export default axios.create({
    headers: {
        "Access-Control-Allow-Origin": "*",
        'x-api-key': '5be42cf9-0f7d-4d74-911e-1859ff47336c'
    }
});